import * as _ from "lodash";
import { Metric } from "./metric";

export interface MetricKey {
    name: string;
    color: string;
    iconPath: string;
}

export class KeyedMetrics {
    private _metrics = new Map<MetricKey, Metric>();

    get keys(): MetricKey[] {
        return [...this._metrics.keys()];
    }

    get total(): number {
        return this.getTotalForKeys(this.keys);
    }

    getMetricForKey(key: MetricKey): Metric {
        return this._metrics.get(key) || Metric.empty();
    }

    setMetricForKey(key: MetricKey, metric: Metric) {
        this._metrics.set(key, metric);
    }

    getValueForKey(key: MetricKey): number {
        return this.getMetricForKey(key).value;
    }

    getTotalForKeys(keys: MetricKey[]): number {
        return _.sumBy(keys, it => this.getMetricForKey(it).total);
    }

    filterWithKeys(keys: MetricKey[]): KeyedMetrics {
        let metrics = new KeyedMetrics();
        keys.forEach(it => metrics.setMetricForKey(it, this.getMetricForKey(it)));
        return metrics;
    }

    aggregateFrom(metrics: KeyedMetrics) {
        for (let key of metrics.keys) {
            this.setMetricForKey(key, Metric.aggregate(this.getMetricForKey(key), metrics.getMetricForKey(key)));
        }
    }

    flatten(): KeyedMetrics {
        let res = new KeyedMetrics();
        for (let key of this.keys) {
            let metric = this.getMetricForKey(key);
            if (metric.hasSubMetrics) {
                res.aggregateFrom(metric.subMetrics);
            } else {
                res.setMetricForKey(key, metric);
            }
        }
        return res;
    }

    static isEqual(a: KeyedMetrics, b: KeyedMetrics) {
        if (!_.isEqual(a.keys, b.keys)) {
            return false;
        }
        return a.keys.every(it => Metric.isEqual(a.getMetricForKey(it), b.getMetricForKey(it)));
    }

    static interpolate(a: KeyedMetrics, b: KeyedMetrics, t: number) {
        let metrics = new KeyedMetrics();
        for (let key of _.union(a.keys, b.keys)) {
            let aMetric = a.getMetricForKey(key);
            let bMetric = b.getMetricForKey(key);
            metrics.setMetricForKey(key, Metric.interpolate(aMetric, bMetric, t));
        }
        return metrics;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/keyedMetrics.ts